import { ResearchCategory, ResearchFilter } from '@snapi/types';

interface FilterableResearch {
  research: {
    category: ResearchCategory;
    condition: string[];
  };
  percentage: number;
  other: number;
  unclassified: number;
}

export const filterResearch = (
  { research: { category, condition } }: Pick<FilterableResearch, 'research'>,
  filter: ResearchFilter
) => {
  if (filter.categories.length === 0 && filter.conditions.length === 0) {
    return true;
  }

  const includesByCondition =
    filter.conditions.length === 0
      ? true
      : condition.some((condition) => filter.conditions.includes(condition));

  if (!includesByCondition) {
    return false;
  }

  if (filter.categories.length === 0 || filter.categories.includes(category)) {
    return true;
  }

  return (
    filter.categories.includes(ResearchCategory.other) &&
    (category === ResearchCategory.unclassified ||
      category === ResearchCategory.unknown)
  );
};

const overlapPercentage = (
  parent: FilterableResearch,
  children: FilterableResearch[],
  filter: ResearchFilter
) => {
  const parentMatches = filterResearch(parent, filter);

  if (children.length === 0) {
    return parentMatches ? parent.percentage : 0;
  }

  const filteredChildren = children
    .filter((child) => ResearchFilterUtils.filterResearch(parent, filter))
    .reduce((sum, { percentage }) => sum + percentage, 0);

  const base = parentMatches ? parent.other + parent.unclassified : 0;

  return base + filteredChildren;
};

export const ResearchFilterUtils = {
  filterResearch,
  overlapPercentage,
};
